import * as React from "react";

interface IProps {
    wordingHtml: React.ReactNode;
}

export class HeadsUpPanel extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div className="section-panel banner banner-info">
                {this.props.wordingHtml}
            </div>
        )
    }

}
